import { SVG, SVGProps } from './svg'

export function IconToolCurve(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M17.87 11.7a2 2 0 01-3.74 0 8.54 8.54 0 00-6.42 6.43 2 2 0 11-1-.11 9.54 9.54 0 017.31-7.31 2 2 0 013.96 0 9.54 9.54 0 017.3 7.31 2 2 0 11-1 .11 8.54 8.54 0 00-6.4-6.42zM17 11a1 1 0 11-2 0 1 1 0 012 0zM7 21a1 1 0 100-2 1 1 0 000 2zm19-1a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </SVG>
  )
}
